import Layout from 'components/layout/Layout'
import DynamicTariff from 'features/dynamic-tariff/DynamicTariff'
import { DynamicTariffProps } from 'features/dynamic-tariff/types'
import { log } from 'utils/logging'
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import { DEFAULT_NAMESPACES } from 'constants/i18n'
import { cmsLib } from 'lib'
import { faqCategoriesSlugs } from 'constants/faq-categories'
import { FAQCategories } from 'features/faq-page/types'
import { useTranslation } from 'next-i18next/pages'
import { SeoProps } from 'components/seo/types'
import { getLowerCaseLanguage } from 'utils/language'

const DynamicTariffPage = (props: DynamicTariffProps) => {
  // i18n
  const { t } = useTranslation('dynamicTariff')

  // Constants
  const seo: SeoProps = {
    title: t(($) => $.seo.title),
    description: t(($) => $.seo.description)
  }

  return (
    <Layout {...{ seo }}>
      <DynamicTariff {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  const language = getLowerCaseLanguage(locale)
  const [data, categories] = await Promise.all([
    cmsLib.getDynamicTariffPage(language),
    cmsLib.getFaqCategories(faqCategoriesSlugs[FAQCategories.DYNAMIC_PRICES], language)
  ])

  if (!data) {
    log({ error: 'No content found for dynamic prices landingspage', identifier: '[CMS:dynamicPrices:getStaticProps]' })

    return {
      notFound: true,
      revalidate: 5
    }
  }

  return {
    props: {
      faqCategories: categories,
      testimonials: data.testimonials,
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'dynamicTariff'], i18nConfig))
    },
    revalidate: 600
  }
}

export default DynamicTariffPage
